const { REACT_APP_LIFERAY_HOST, REACT_APP_CREDENTIALS } = process.env;

export const LIFERAY_HOST = window?.Liferay?.ThemeDisplay?.getPortalURL() || REACT_APP_LIFERAY_HOST || window.location.origin; // Fallback to current origin if not defined

// export const API_HEADERS = {
//     "Content-Type": "application/json",
//     Authorization: window?.Liferay?.authToken ? window?.Liferay?.authToken : "Basic " + btoa(String(REACT_APP_CREDENTIALS)),
//     "x-csrf-token": window?.Liferay?.authToken,
// };